var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKakaoPay = function SvgKakaoPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kakao_pay_svg__a)",
    fill: "#767676"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.332 0C3.282 0 0 2.457 0 5.487c0 1.947 1.36 3.656 3.402 4.631l-.692 2.445a.196.196 0 0 0 .054.209.216.216 0 0 0 .277.012l2.971-1.9c.431.058.872.092 1.32.092 4.047 0 7.332-2.456 7.332-5.486S11.38 0 7.332 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.84 10.042v3.542h-2.664V.522h1.878l.327.829C20.946.816 21.805.246 23.192.246c2.61 0 3.85 1.849 3.83 4.838 0 3.128-1.915 5.132-4.652 5.132-.528 0-.93-.035-1.53-.174Zm0-7.415v5.651c.146.016.51.05.858.05 1.898 0 2.627-1.26 2.627-3.247 0-1.745-.491-2.8-2.005-2.8-.492 0-1.04.14-1.477.346h-.004ZM32.825 4.2h1.514v-.31c0-1.035-.622-1.52-1.698-1.52-.822 0-1.878.225-2.737.624L29.175 1.3c.95-.623 2.407-1.054 3.703-1.054 2.553 0 3.94 1.28 3.94 3.717v5.993H34.94l-.274-.794c-1.076.744-2.062 1.054-2.954 1.054-1.952 0-3.048-1.105-3.048-2.973 0-1.988 1.46-3.043 4.157-3.043h.004Zm1.514 3.334V5.806h-1.224c-1.366 0-2.062.465-2.062 1.399 0 .71.385 1.054 1.167 1.054.728 0 1.66-.345 2.115-.725h.004ZM44.88 8.988c-.93 2.35-2.043 4.062-3.667 5.012l-1.64-1.434c.948-.78 1.623-1.539 2.205-2.558L38.242.868l2.644-.675 2.262 7.415 2.243-7.45 2.61.69-3.118 8.14h-.004Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kakao_pay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v14H0z"
  })))));
};

export default SvgKakaoPay;